export default "__VITE_ASSET__DWx6nyB3__"